export default __webpack_public_path__ + "static/media/placeholder_portfolio02-nl-web.430e0f66.png";